import { assertPresent, compareByDate } from '@luminovo/commons';
import { SourcingTemplateTags } from '@luminovo/http-client';
import { useSuspenseHttpQuery } from '../http/useHttpQuery';
export function useSourcingTemplate(id: string) {
    return useSuspenseHttpQuery('GET /sourcing-templates/:id', {
        pathParams: { id: id },
    });
}

export function useSourcingTemplates() {
    return useSuspenseHttpQuery(
        'GET /sourcing-templates',
        {},
        {
            select: (data) => Array.from(data.items).sort(compareByDate((s) => s.updated_at, { type: 'ascending' })),
        },
    );
}

// TODO(sourcing_templates): Remove default once we have fully shaped sourcing template tags
export function useDefaultSourcingTemplate(_: SourcingTemplateTags = SourcingTemplateTags.Sourcing) {
    return useSuspenseHttpQuery(
        'GET /sourcing-templates',
        {},
        {
            select: (data) => assertPresent(data.items.find((sourcingTemplate) => sourcingTemplate.is_default)),
        },
    );
}
